import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate } from '../../../../../utils/util';
import HomeDefault from '../../../../../components/HomeDefaultComponent';

const Home = (props) => {
    const type = props.location?.state?.registrationType;
    const showDescription = props.location?.state?.showDescription;
    const titleType = props.location?.state?.title;
    const icon = props.location?.state?.icon;
    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, { route: { pathname: 'insert', state: { registrationType: type, showDescription: showDescription, title: titleType, icon: icon } }, icon: 'mdi mdi-plus-box-outline', text: 'Inserir' }];
        menuItems = [...menuItems, { route: { pathname: 'list', state: { registrationType: type, showDescription: showDescription, title: titleType, icon: icon } }, icon: 'mdi mdi-clipboard-list-outline', text: 'Listar' }];
        return menuItems;
    };

    const title = { icon: "mdi mdi-domain", label: translate('deemsqp:menu.registrations') };

    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: icon, label: titleType }];
        return subtitlesItems;
    }

    return (
        <HomeDefault menu={menu()} title={title} subtitles={subtitles()} />
    );
};


const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Home)));
